import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { FlexBox } from "app/components/React/Legends/BulletLegends";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledOnboardingHubHoorayWrapper = styled.div`
    margin: 0 auto;
`;
export const StyledOnboardingHubBodyCompleted = styled(FlexColumn)`
    gap: 8px;
    padding: 0 12px;
`;
export const StyledOnboardingHubCompletedTitle = styled.div`
    ${setFontVariant("subsectionTitle", colorsPalettes.carbon[500])};
    line-height: 24px;
    font-weight: 600;
    font-feature-settings: "liga" off;
    text-align: center;
`;
export const StyledOnboardingHubCompletedSubTitle = styled.div`
    ${setFontVariant("sectionTitle", colorsPalettes.carbon[300])};
    font-feature-settings: "liga" off;
    text-align: center;
`;

export const StyledSidebarOnboardingHubHoorayWrapper = styled(FlexBox)`
    gap: 4px;
`;
export const StyledSidebarOnboardingHubCompletedTitle = styled.div`
    ${setFontVariant("dataTable2", colorsPalettes.carbon[400])};
    font-feature-settings: "liga" off;
`;
